import React, { useEffect, useState } from "react";
import alanBtn from "@alan-ai/alan-sdk-web";
import NewsCards from "./components/NewsCards/NewsCards";
import useStyles from "./styles.js";
import wordsToNumbers from "words-to-numbers";
import { Typography } from "@material-ui/core";

const alanKey =
    "c21be1f0c15d8f92d90b29e9a2508fc52e956eca572e1d8b807a3e2338fdd0dc/stage";

const App = () => {
    const [newsArticles, setNewsArticles] = useState([]);
    const [activeArticle, setActiveArticle] = useState(-1);
    const classes = useStyles();

    useEffect(() => {
        alanBtn({
            key: alanKey,
            onCommand: ({ command, articles, number }) => {
                if (command === "newHeadlines") {
                    setNewsArticles(articles);
                    setActiveArticle(-1);
                } else if (command === "highlight") {
                    setActiveArticle(
                        (prevActiveArticle) => prevActiveArticle + 1
                    );
                } else if (command === "open") {
                    const parsedNumber =
                        number.length > 2
                            ? wordsToNumbers(number, { fuzzy: true })
                            : number;
                    const article = articles[parsedNumber - 1];
                    if (parsedNumber > 20) {
                        alanBtn().playText("Please try again.");
                    } else if (article) {
                        window.open(article.url, "_blank");
                        alanBtn().playText("Opening..");
                    }
                }
            },
        });
    }, []);

    return (
        <div>
            <div className={classes.logoContainer}>
                <Typography
                    className={classes.alanLogo}
                    variant="h2"
                    component="h2"
                >
                    Let's Catch Up
                </Typography>
            </div>
            <NewsCards articles={newsArticles} activeArticle={activeArticle} />
        </div>
    );
};

export default App;
